import template from './leave_available_by_company_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class LeaveAvailableByCompanyHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveAvailableByCompanyHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveAvailableByCompanyHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveAvailableByCompanyHelp',
	dialog_class: LeaveAvailableByCompanyHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_available_by_company_help',
	provider: 'ps'
};
